import {
  TEAMMATE_APP_DEV_URL,
  TEAMMATE_APP_URL,
  SIGNUP_FLOW_PATH,
  mapToTeammateAppLocale,
} from 'marketing-site/lib/teammateAppUrl'

export function localiseURL(url: string, locale: string): string {
  if (
    url.startsWith(`${TEAMMATE_APP_URL}${SIGNUP_FLOW_PATH}`) ||
    url.startsWith(`${TEAMMATE_APP_DEV_URL}${SIGNUP_FLOW_PATH}`)
  ) {
    const mappedLocale = mapToTeammateAppLocale(locale)
    if (mappedLocale) {
      const urlObj = new URL(url)
      urlObj.searchParams.append('locale', mappedLocale)
      return urlObj.toString()
    }
  }
  if (locale === 'en-US' || !locale || !url.startsWith('/') || url.startsWith(`/${locale}/`)) {
    return url
  }
  return '/' + locale + url
}
